import forEach from "lodash-es/forEach"
import { useIsomorphicLayoutEffect } from "react-use"

import { EAppAnimationName, type TAppDispatcher, useAppDispatcher } from "@/3514/store/app"
import type { TEmptyCallback } from "@/shared/types/functions"

const pageAnimationKeys: EAppAnimationName[] = [
    EAppAnimationName.CoachingSessions_ScheduleBox,
    EAppAnimationName.CoachingSessions_LiveSession,
    EAppAnimationName.CoachingSessions_UpcomingSessions,
    EAppAnimationName.CoachingSessions_PastSessions
]

function useCoachingSessionsAnimationsReset(seenAnimationsMap: Map<number, boolean>, uniqueId: number): void {
    const appDispatcher: TAppDispatcher = useAppDispatcher()

    useIsomorphicLayoutEffect((): TEmptyCallback => {
        const hasSeen: boolean = seenAnimationsMap.has(uniqueId)

        if (hasSeen) {
            forEach<EAppAnimationName>(pageAnimationKeys, (key: EAppAnimationName): void =>
                appDispatcher.completeAnimation(key)
            )
            seenAnimationsMap.delete(uniqueId)
        }

        return (): void => {
            if (hasSeen) {
                forEach<EAppAnimationName>(pageAnimationKeys, (key: EAppAnimationName): void =>
                    appDispatcher.resetAnimation(key)
                )
            }
        }
        // dont update deps list, participant\seen animations logic will broke
    }, [])
}

export { useCoachingSessionsAnimationsReset }
